import React from 'react'

const CapitalDansSection = () => {
  return (
    <>
     <section className="dans-section">

  <div className="container banner-div-top">
    <div className="row">
      <div className="col-lg-4 col-md-7 mx-lg-auto ms-auto">
        <div className="dans-box">
          <svg xmlns="http://www.w3.org/2000/svg" width={350} height={458} viewBox="0 0 350 458" fill="none">
            <path d="M0 174.052V441.772C0 450.355 6.92123 457.618 15.8195 457.618H334.181C342.75 457.618 350 450.685 350 441.772V174.052C350 169.76 348.353 165.799 345.387 162.828L187.524 4.7041C181.262 -1.56803 171.374 -1.56803 165.442 4.7041L4.94327 162.828C1.97717 165.799 0.329865 169.76 0.329865 174.052H0Z" fill="#007367" />
          </svg>
          <div className="dans-box-inner">
            <h1>Collaboration</h1>
            <p>L'entreprise favorise un environnement de travail collaboratif où les employés viennent en unité pour atteindre des objectifs communs et surtout se bâtir les uns les autres en partageant librement et sans calculer leurs connaissances et leur expertise.</p>
            {/* <p>L'entreprise favorise un environnement de travail collaboratif où les employés peuvent travailler en équipe pour atteindre des objectifs communs et partager leurs connaissances.</p> */}
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 col-md-7">
        <div className="dans-box mt-minus">
          <svg xmlns="http://www.w3.org/2000/svg" width={350} height={458} viewBox="0 0 350 458" fill="none">
            <path d="M0 174.052V441.772C0 450.355 6.92123 457.618 15.8195 457.618H334.181C342.75 457.618 350 450.685 350 441.772V174.052C350 169.76 348.353 165.799 345.387 162.828L187.524 4.7041C181.262 -1.56803 171.374 -1.56803 165.442 4.7041L4.94327 162.828C1.97717 165.799 0.329865 169.76 0.329865 174.052H0Z" fill="#007367" />
          </svg>
          <div className="dans-box-inner">
            <h1>Flexibilité</h1>
            <p>Beatimo offre une flexibilité au niveau des horaires de travail et du lieu de travail, ce qui permet aux employés d'équilibrer plus facilement leur vie.</p>
            {/* <p>Beatimo offre une flexibilité au niveau des horaires de travail et du lieu de travail, ce qui permet aux employés d'équilibrer plus facilement leur vie.</p> */}
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="ms-auto col-lg-4 col-md-7">
        <div className="dans-box mt-minus">
          <svg xmlns="http://www.w3.org/2000/svg" width={350} height={458} viewBox="0 0 350 458" fill="none">
            <path d="M0 174.052V441.772C0 450.355 6.92123 457.618 15.8195 457.618H334.181C342.75 457.618 350 450.685 350 441.772V174.052C350 169.76 348.353 165.799 345.387 162.828L187.524 4.7041C181.262 -1.56803 171.374 -1.56803 165.442 4.7041L4.94327 162.828C1.97717 165.799 0.329865 169.76 0.329865 174.052H0Z" fill="#007367" />
          </svg>
          <div className="dans-box-inner">
            <h1>Innovation</h1>
            <p>Beatimo encourage l'innovation, laissant espace et liberté pour que la créativité de nos employés puisse améliorer les produits, les outils et les processus utilisés pour servir nos clients avec <span> excellence.</span></p>
            {/* <p>Beatimo encourage l'innovation, permettant aux employés de proposer et de mettre en œuvre de nouvelles idées pour améliorer les produits et les processus.</p> */}
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="mx-lg-auto col-lg-4 col-md-7">
        <div className="dans-box mt-minus">
          <svg xmlns="http://www.w3.org/2000/svg" width={350} height={458} viewBox="0 0 350 458" fill="none">
            <path d="M0 174.052V441.772C0 450.355 6.92123 457.618 15.8195 457.618H334.181C342.75 457.618 350 450.685 350 441.772V174.052C350 169.76 348.353 165.799 345.387 162.828L187.524 4.7041C181.262 -1.56803 171.374 -1.56803 165.442 4.7041L4.94327 162.828C1.97717 165.799 0.329865 169.76 0.329865 174.052H0Z" fill="#007367" />
          </svg>
          <div className="dans-box-inner">
            <h1>Culture</h1>
            <p>Beatimo promeut une culture d'entreprise positive et familiale qui mets de l’avant un esprit d’<span>excellence</span>, favorisant ainsi l’accomplissement du plein potentiel de nos employés. </p>
            {/* <p>Beatimo promeut une culture d'entreprise positive, axée sur le bien-être des employés, la diversité et l'inclusion, créant ainsi un environnement de travail stimulant et gratifiant.</p> */}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="h-25vh"></div>
</section>
    </>
  )
}

export default CapitalDansSection
